import React, { useState } from 'react';
import { Helmet } from '../utils/Seo';
import { auth } from '../firebase-config';
import { signInWithPopup, GoogleAuthProvider } from 'firebase/auth';
import { useNavigate, Link } from 'react-router-dom';
import { OWNER_EMAIL } from '../config';

const AdminLogin = () => {
  const [error, setError] = useState('');
  const navigate = useNavigate();

  const handleGoogleLogin = async () => {
    const provider = new GoogleAuthProvider();
    try {
      const result = await signInWithPopup(auth, provider);
      if (result.user.email === OWNER_EMAIL) {
        navigate('/admin');
      } else {
        await auth.signOut();
        setError('Pristup odbijen. Samo ovlašteni račun može pristupiti.');
      }
    } catch (err) {
      setError('Greška prilikom prijave: ' + err.message);
    }
  };

  return (
    <>
      <Helmet>
        <title>Admin Login - Nejira Zukić Weddings</title>
        <meta name="robots" content="noindex, nofollow" />
      </Helmet>

      <div className="min-h-screen bg-[#fcfaf8] flex flex-col items-center justify-center px-6 font-sans">
      <div className="max-w-md w-full text-center space-y-12">
        <div className="space-y-4">
          <Link to="/" className="text-2xl tracking-[0.4em] font-light text-gray-900 block mb-12">
            NEJIRA ZUKIĆ
          </Link>
          <h1 className="text-4xl font-serif text-gray-900">Administracija</h1>
          <p className="text-gray-500 text-sm tracking-widest font-light uppercase">
            Samo za ovlašteni pristup
          </p>
        </div>

        {error && (
          <div className="p-4 bg-red-50 border border-red-100 text-red-600 text-xs tracking-wider rounded-xl">
            {error}
          </div>
        )}

        <div className="pt-8">
          <button 
            type="button" 
            onClick={handleGoogleLogin} 
            className="text-gray-900 px-12 py-4 font-bold tracking-[0.3em] uppercase hover:opacity-50 transition-all border-b border-gray-900 text-xs"
          >
            Prijavi se putem Google-a &rarr;
          </button>
        </div>

        <div className="pt-12">
          <Link to="/" className="text-[10px] tracking-[0.2em] uppercase text-gray-400 hover:text-gray-900 transition-colors">
            Povratak na stranicu
          </Link>
        </div>
      </div>
    </div>
    </>
  );
};

export default AdminLogin;
